import * as angular from 'angular';
import faqService from './bc/faq/faq.service';
import { EDITOR_CONSTANTS } from './editor.constant';
import releaseNotesService from './bc/releaseNotes/releaseNotes.service';
import contentEditorRouter from './content-editor.router';

/** @constant {angular.module} */
const contentEditModule = angular
  .module('ec.opsCenter.contentEditor', [])
  .config(contentEditorRouter)
  .constant('EDITOR_CONSTANTS', EDITOR_CONSTANTS)
  .service('faqService', faqService)
  .service('releaseNotesService', releaseNotesService).name;

export default contentEditModule;



// WEBPACK FOOTER //
// ./src/app/content-editor/content-editor.module.ts